import * as moment from 'moment';

export default class Formatter {
  static formatDate(date_of_birth) {
    return date_of_birth ? moment(date_of_birth).format('ll') : 'N/A'
  }

  static formatBoolean(field): string {
    const status = {
      1: 'Ja',
      0: 'Nee',
    };

    return status[field] || 'N/A';
  };

  static formatMoney(field) {
    return field ? this.formatEuro(field) : 'N/A';
  }

  static formatEuroInWords(amount: string): any {
    return '€: ' + this.formatNumber(amount);
  }

  static formatEuro(amount: string): any {
    return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
      .format(parseFloat(amount));
  }

  static formatNumber(amount) {
    return Number(amount).toLocaleString("nl-NL", { minimumFractionDigits: 2 });
  }

  static formatAddress(address) {
    return address ?
      `${address.address} ${address.city} ${address.country.name}`
      : 'N/A';
  }
}
